import { Component, OnInit, Input, ElementRef, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { NgbModal, NgbModalRef, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportsService } from 'src/app/services/reports/reports.service';
import { SweetAlertService } from 'src/app/services/sweetalert/sweet-alert.service';
import { DeleteTagComponent } from '../delete-tag/delete-tag.component';

@Component({
    selector: 'app-edit-tag',
    templateUrl: './edit-tag.component.html',
    styleUrls: ['./edit-tag.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditTagComponent implements OnInit {

  @Input() data: any;
  tag_name: any;
  tag_color: any;
  newColor: string;
  bgColor: string[] = ['primary', 'secondary', 'success', 'danger', 'warning', 'info'];
  showColors: boolean = false;
  loading: boolean = false;
  tag_id: any;
  inputTagName: any;

  constructor(
    private activeModal: NgbActiveModal,
    private reportService: ReportsService,
    private sweetAlertService: SweetAlertService,
    private modalService: NgbModal, 
    private el: ElementRef
  ) { }

  ngOnInit(): void {
    if (this.data && this.data.tagData) {
      this.tag_id = this.data.tagData.tag_id;
      this.tag_name = this.data.tagData.tag_name;
      this.tag_color = this.data.tagData.tag_color;
      this.inputTagName = this.tag_name;
    }
    this.newColor = this.tag_color;

  }

  closeModel(): void {
    this.activeModal.dismiss('success');
  }


  selectcolorList(colorList: string) {
    this.newColor = colorList;
    this.showColors = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (!this.el.nativeElement.contains(event.target)) {
      this.showColors = false;
    }
  }

  showAllColors() {
    this.showColors = !this.showColors;
  }

  updateTag() {
    if (this.inputTagName !== '') {
      this.loading = true;
      const formData: any = new FormData();
      formData.append('tag_name', this.inputTagName);
      formData.append('tag_color', this.newColor);
      formData.append('tag_id', this.tag_id);
      formData.append('edit_tag', 'edit_tag');
      this.reportService.getTagsCreate(formData).subscribe({
        next: (data) => {
          this.loading = false;
          if (data == "tag_not_found") {
            this.sweetAlertService.sweetAlert("error", "Tag not found");
          }
          else if (data == "error_in_update") {
            this.sweetAlertService.sweetAlert("error", "Error in update");
          }
          else if (data == "available") {
            this.sweetAlertService.sweetAlert("error", "Tag name already used");
          }
          else if (data == "max_characters") {
            this.sweetAlertService.sweetAlert("error", "Maximum characters for tag name is 20");
          }
          else if (data == "success") {
            this.sweetAlertService.sweetAlert("success", "Tag updated successfully");
            // this.closeModel();
            this.activeModal.close('success');
          }
        },
        error: () => {
          this.loading = false;
        }
      })
    }
    else {
     this.sweetAlertService.sweetAlert("error", "Please fill the field.");
    }
  }

  deleteTag(deleteTag: any) {
    const dialogRef: NgbModalRef = this.modalService.open(DeleteTagComponent, { centered: true, size: 'sm',  backdrop: 'static',
            keyboard: false,
            windowClass: 'force-close-modal',
            backdropClass: 'force-close-backdrop', });
    dialogRef.componentInstance.deleteTag = {
      getDeleteTag: deleteTag,
    };
    dialogRef.result.then(
      (result) => {
        console.log('Modal closed with result: ', result);
        if (result === 'success') {
          this.activeModal.dismiss('success');
        }
      },
      (reason) => {
        console.log('Modal dismissed with reason: ', reason);
        if (reason === undefined) {
          
        } else {
          this.activeModal.dismiss('success');
        }
      }
    );
  }

}
